/**
 * @template Struct, Field, NewStruct
 * @typedef {Omit<Struct, Field> & NewStruct} Override
 */

/**
 * @typedef {"adminSettings"|"managerDashboard"|"managerPortal"} AppName
 * @typedef {"employmentBillboard"|"globalConfigurations"} AdminProductName
 *
 * @typedef {"employmentBillboard"|
 *  "dailyShiftBidding"|"employmentBillboard"|"employmentBillboardRequests"|"employmentBillboardSettings"
 * } ManagerDashboardProductName
 *
 * @typedef {"employmentBillboard"|
 * "employmentBillboardArchive"|"employmentBillboardRequests"|"employmentBillboardSettings"
 * } ManagerPortalProductName
 *
 * @typedef {AdminProductName|ManagerDashboardProductName|ManagerPortalProductName} ProductName
 * @typedef {{
 *  name: AppName;
 *  api: "central"|"dimensions";
 *  env_sso: "active"|"inactive";
 *  sso: "string";
 *  token: boolean;
 * }} Product
 */

/**
 * @template T
 * @typedef {T & Override<Product, "name", { name: ProductNames }> & {
 *  env: string[];
 *  status: "active"|"inactive";
 *  settingsName: string;
 * }} CustomProduct
 */

/** @type {Product[]} */
export const commonApps = [
    {
        name: "adminSettings",
        api: "dimensions",
        env_sso: "active",
        sso: true,
        token: true,
    },
    {
        name: "managerPortal",
        api: "dimensions",
        env_sso: "active",
        sso: true,
        token: true,
    },
];

export const managerViews = ["Requests", "Settings", "Archive"];
export const globalConfigViews = ["ArchivingRules"];
export const archiveViews = ["Archive"];


/** @type {CustomProduct<{ managerViews: string[]; }} */
export const employmentBillboard = {
    name: "employmentBillboard",
    api: "dimensions",
    env: ["admin", "manager"],
    managerViews,
    status: "active",
    settingsName: "Employee Billboard",
    env_sso: "active",
    sso: true,
    token: true,
};

/** @type {CustomProduct<{ globalConfigViews: string[]; }} */
export const globalConfigurations = {
    name: "globalConfigurations",
    api: "dimensions",
    env: ["admin"],
    globalConfigViews,
    status: "active",
    settingsName: "Global Configurations",
    env_sso: "active",
    sso: true,
    token: true,
};


/** @type {CustomProduct<{ archiveViews: string[]; }} */
export const archive = {
    name: "archive",
    api: "dimensions",
    env: ["admin"],
    archiveViews,
    status: "active",
    settingsName: "Archive",
    env_sso: "active",
    sso: true,
    token: true,
};

